import {FunctionComponent} from "react";
import {Route, Routes, useParams} from "react-router-dom";
import {adminPages} from "../../context/pageTree";
import {AdminDataProvider} from "./contexts/AdminDataContext";

const AdminRouter: FunctionComponent = () => {
  const params = useParams();
  const managerId = params.manager;

  if (!managerId) return null;

  return (
    <AdminDataProvider managerId={managerId}>
      <Routes>
        {adminPages.map((page, i) => (
          <Route
            path={page.link}
            element={<page.element/>}
            key={"page-" + i}
          />
        ))}
      </Routes>
    </AdminDataProvider>
  );
};

export default AdminRouter;
